export function getCurrencyValueAsNumber(
  currencyValue: string,
  decimalMarker: ',' | '.',
): number {
  const reverseMarker = decimalMarker === ',' ? '.' : ',';
  const [integerPart, decimalPart = '00'] = currencyValue.split(decimalMarker);
  const number = integerPart.split(reverseMarker).join('');
  return parseFloat(`${number}.${decimalPart}`);
}
